import Simple from "../../../Components/InputFields/Simple";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import Divider from "./Divider";
import GoogleAuthButton from "./GoogleAuthButton";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  getNextFromRedirect,
  getRedirectFromNext,
} from "../../../helper/nextRedirect";
import BackToHome from "./BackToHome";
import { API_BASE_URL } from "../../../config/api";
import RememberMe from "./RememberMe";

export default function Container({
  text,
  subtext,
  signupData,
  setSignupData,
  setStep,
}) {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(false);

  const { search } = useLocation();
  const urlRef = new URLSearchParams(search).get("ref");
  const nextParam = new URLSearchParams(search).get("next");
  const redirectFromNext = getRedirectFromNext(nextParam);
  const storedRedirect = localStorage.getItem("post_login_redirect");
  const redirectPath = redirectFromNext || storedRedirect;
  const nextForRedirect = nextParam || getNextFromRedirect(redirectPath);
  const signinHref = nextForRedirect
    ? `/SignIn?next=${nextForRedirect}`
    : "/SignIn";

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (urlRef) {
      setSignupData((pre) => ({ ...pre, referral_code: urlRef }));
    }
  }, [setSignupData, urlRef]);

  useEffect(() => {
    if (redirectFromNext) {
      localStorage.setItem("post_login_redirect", redirectFromNext);
    }
  }, [redirectFromNext]);

  const [emailBlur, setEmailBlur] = useState(false);
  const [emailValid, setEmailValid] = useState(true);
  const [referralCodeInvalid, setReferralCodeInvalid] = useState(false);

  const [fieldsRequired, setFieldsRequired] = useState(false);

  const [emailTaken, setEmailTaken] = useState(false);

  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  useEffect(() => {
    if (!isValidEmail(signupData.email)) {
      setEmailValid(false);
    } else {
      setEmailValid(true);
    }
  }, [signupData.email]);

  useEffect(() => {
    setEmailTaken(false);
  }, [emailBlur]);

  const handleEmailChange = (e) => {
    setSignupData({ ...signupData, email: e.target.value });
  };
  const handleReferralCodeChange = (e) => {
    setReferralCodeInvalid(false);
    setSignupData({ ...signupData, referral_code: e.target.value });
  };
  const handleSignup = async (e) => {
    e.preventDefault();
    if (
      signupData.email === "" ||
      signupData.email === null ||
      signupData.email === undefined
    ) {
      setFieldsRequired(true);
      return;
    } else {
      setFieldsRequired(false);
    }
    if (!emailValid) {
      return;
    }
    setLoading(true);
    try {
      let emailJsonBody = {
        email: signupData.email,
      };
      const response = await fetch(
        `${API_BASE_URL}auth/trader/signup/check-email/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(emailJsonBody),
        },
      );

      const result = await response.json();

      // Check if server responded with error status
      if (result.status === "failure") {
        setEmailTaken(true);
      }
      if (signupData.referral_code !== "") {
        let refJsonBody = {
          referral_code: signupData.referral_code,
        };
        const refResponse = await fetch(
          `${API_BASE_URL}auth/trader/signup/check-referral-code/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(refJsonBody),
          },
        );

        const refResult = await refResponse.json();
        if (refResult.status === "failure") {
          setReferralCodeInvalid(true);
          setLoading(false);
          return;
        }
      }
      if (result.status === "failure") {
        setLoading(false);
        return;
      }
      setLoading(false);
      setStep(2);
    } catch (error) {
      console.error("POST request failed:", error);
      setLoading(false);
      return null; // or throw error again if you want
    }
  };

  useEffect(() => {
    if (emailTaken) {
      setHasError(true);
      setError("این ایمیل قبلا ثبت نام شده است");
    } else if (!emailValid && emailBlur) {
      setHasError(true);
      setError("لطفا یک ایمیل معتبر وارد کنید");
    } else if (fieldsRequired) {
      setHasError(true);
      setError("لطفا تمامی فیلدها را پر کنید");
    } else if (referralCodeInvalid) {
      setHasError(true);
      setError("کد معرف نامعتبر است");
    } else {
      setHasError(false);
    }
  }, [
    fieldsRequired,
    emailValid,
    emailBlur,
    emailTaken,
    referralCodeInvalid,
  ]);
  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            {text}
          </h1>
          <BackToHome />
        </div>
        <span className="text-xs font-light text-zi-text-light/50 dark:text-zi-text-dark/50">
          {subtext}
        </span>
      </div>

      <div>
        <form className="flex flex-col gap-5" autoComplete="off">
          <Simple
            placeholder="آدرس ایمیل"
            type="email"
            id="email"
            formValue={signupData.email}
            formOnChange={handleEmailChange}
            emailBlur={emailBlur}
            setEmailBlur={setEmailBlur}
            emailValid={emailValid}
          />
          <div className="flex flex-col gap-2">
            <Simple
              placeholder="کد معرف (اختیاری)"
              type="text"
              id="referral_code"
              formValue={signupData.referral_code}
              formOnChange={handleReferralCodeChange}
              readOnly={urlRef}
            />
            <RememberMe />
          </div>
          {!loading ? (
            <GradientBlue
              type="submit"
              value="مرحله بعدی"
              onClick={handleSignup}
            />
          ) : (
            <GradientBlue
              type="submit"
              isLoader={true}
              onClick={handleSignup}
            />
          )}
        </form>
        {hasError && (
          <p className="text-amber-400 text-sm font-extralight mt-1">{error}</p>
        )}
        <div className="flex flex-col gap-0 pt-2.5">
          <Divider text="یا با گوگل ادامه دهید" />
          <GoogleAuthButton text="ثبت‌نام با گوگل" />
        </div>
        <div className="flex items-center justify-center gap-1 py-2.5 mt-2.5">
          <p className="text-xs text-zi-text-light/50 dark:text-zi-text-dark/50">حساب کاربری دارید؟</p>
          <Link
            to={signinHref}
            className="text-sm text-zi-blue-light hocus:underline"
          >
            وارد شوید
          </Link>
        </div>
      </div>
    </div>
  );
}
